export const iconFontAwesomeMaritimeAnchorLock = (
	<i className="fa-solid fa-anchor-lock"></i>
);
